import styled from '@emotion/styled'
import { X } from 'lucide-react'
import {
    PRIMARY_PAGE_TEXT_COLOR_VAR,
    PRIMARY_PAGE_FILL_COLOR_VAR,
} from '../../context/CustomizationContextProvider'
import { getTypographyRoleStyle } from '../../style/typography'
import { scaledFontSize } from '../../style/scrollingLayout'

const FilterPillContainer = styled.div({
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    padding: '4px 8px',
    borderRadius: '0.2rem',
    background: `var(${PRIMARY_PAGE_FILL_COLOR_VAR})`,
    border: '1px solid rgba(0, 0, 0, 0.1)',
    ...getTypographyRoleStyle('badgeText', {
        fontWeight: 400,
    }),
    fontSize: scaledFontSize(12),
    color: `var(${PRIMARY_PAGE_TEXT_COLOR_VAR})`,
})

const PillText = styled.span`
    flex: 1;
    color: var(${PRIMARY_PAGE_TEXT_COLOR_VAR});
`

const PillCloseButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    border: none;
    cursor: pointer;
    padding: 0;
    margin: 0;
    color: var(${PRIMARY_PAGE_TEXT_COLOR_VAR});
    opacity: 0.7;
    transition: opacity 0.15s ease;

    &:hover {
        opacity: 1;
    }

    &:focus {
        outline: none;
    }
`

const FilterPill: React.FC<{
    filter: string
    onFilterRemove: (filter: string) => void
}> = ({ filter, onFilterRemove }) => {
    return (
        <FilterPillContainer>
            <PillText>{filter}</PillText>
            <PillCloseButton onClick={() => onFilterRemove(filter)}>
                <X size={16} />
            </PillCloseButton>
        </FilterPillContainer>
    )
}

export { FilterPill }
